import { useContext } from "react";
import { CustomIcon } from "../../../../components";
import { ICreateAndUpdateArea } from "../../../../types/area.interface";
import Context from "../../../../context";
import { useTranslation } from "react-i18next";

const DescriptionArea = ({
  onEdit,
  onRemove,
  selectedArea,
}: {
  item?: ICreateAndUpdateArea;
  onEdit?: (area: ICreateAndUpdateArea) => void;
  onRemove?: (area: ICreateAndUpdateArea) => void;
  selectedArea?: any;
}) => {
  const { t } = useTranslation();
  return (
    <div className="area-description">
      <div>
        {selectedArea?.title}
        <div>
          {onEdit && (
            <CustomIcon
              onClick={() => onEdit(selectedArea as ICreateAndUpdateArea)}
              icon="fa fa-pen"
              hoverTitle={t("update")}
            />
          )}
          {onRemove && (
            <CustomIcon
              onClick={() => onRemove!(selectedArea as ICreateAndUpdateArea)}
              icon="fa fa-trash"
              hoverTitle={t("remove")}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DescriptionArea;
